<template>
    <div>
        <div v-for="cg in contacts">
            <template v-if="cg.contactType==='_whatsapp'">
                <div v-for="item in cg.items" class="col-xs-12" :class="'col-md-'+colWidth">
                    <div class="agx-footer-col">
                        <div class="agx-cat-name">WhatsApp</div>
                        <div class="agx-item">
                            {{item.contact}}
                            <a :href="'https://wa.me/'+item.contact" target="_blank">
                                <img class="agx-whatsapp-icon" src="/images/sns/whatsapp.png" />
                            </a>
                        </div>
                    </div>
                </div>
            </template>
            <template v-if="cg.contactType==='_email'">
                <div v-for="item in cg.items" class="col-xs-12" :class="'col-md-'+colWidth">
                    <div class="agx-footer-col">
                        <div class="agx-cat-name">Email</div>
                        <div class="agx-item">
                            {{item.contact}}
                            <a class="glyphicon glyphicon-send agx-email-icon" :href="'mailto:'+item.contact"></a>
                        </div>
                    </div>
                </div>
            </template>
            <template v-if="cg.contactType==='_phone'">
                <div v-for="item in cg.items" class="col-xs-12" :class="'col-md-'+colWidth">
                    <div class="agx-footer-col">
                        <div class="agx-cat-name">Phone</div>
                        <div class="agx-item">
                            {{item.contact}}
                            <a class="glyphicon glyphicon-send agx-phone-icon" :href="'tel:'+item.contact"></a>
                        </div>
                    </div>
                </div>

            </template>
        </div>
    </div>
</template>


<script>
    export default {
        components: {
            
        },
        props: ["contacts"],
        data: function () {
            return {
                
            }
        },
        computed:{
            colWidth: function () {
                var grpsCount = this.contacts !== null ? this.contacts.length : 0;
                if (grpsCount == 0) return 12;
                var width = 12 / grpsCount;
                if (width < 4) return 4;
                return width;
            }
        },
        mounted: function () {

        }
    }
</script>